<template>
  <div class="vant-table">
    <table cellspacing="0" :style="bgcolor" style="width:100%" class="table">
      <tr>
        <th class="th" v-for="(item, index) in option.column" :key="index">{{ item.label }}</th>
      </tr>
      <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
        <td class="td" v-for="(context, i) in option.column" :key="i" v-html="item[context.prop]"></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    bgcolor: Object,
    tableData: Array,
    option: Object
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>
.vant-table {
  .table {
    border: 1px solid #ccc;
    .th {
      height: 1.074074rem;
      line-height: 1.074074rem;
      background-color: #fff;
      text-align: center;
      border: 1px solid #ccc;
      font-size: 24px;
      padding: 12px;
      white-space: nowrap;
    }
    .td{
      padding: 12px;
      font-size: 20px;
      text-align: center;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      white-space: nowrap;
    }
    .list-tr {
      height: 1.074074rem;
      line-height: 1.074074rem;

      td {
        vertical-align: middle;
      }
    }
    .list-tr:nth-child(2n) {
      background-color: #fff;
    }
  }
}
</style>
